import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=5c459040&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=5c459040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c459040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c459040')) {
      api.createRecord('5c459040', component.options)
    } else {
      api.reload('5c459040', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=5c459040&scoped=true&", function () {
      api.rerender('5c459040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26mCb7bH5dRMd/JS/comp/GuestBoxKids.vue"
export default component.exports